import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private currentLang = new BehaviorSubject<string>('en');
    currentLang$ = this.currentLang.asObservable();

    constructor(private translate: TranslateService) {
        // Set default language
        this.translate.setDefaultLang('en');

        if (typeof window !== 'undefined' && window.localStorage) {
            // Get language from localStorage or use default
            const savedLang = localStorage.getItem('language') || 'en';
            this.setLanguage(savedLang);
        }
    }

    setLanguage(lang: string) {
        this.translate.use(lang);
        if (typeof window !== 'undefined' && window.localStorage) {
            localStorage.setItem('language', lang);
        }
        this.currentLang.next(lang);
    }

    getCurrentLang(): string {
        return this.currentLang.value;
    }
} 